var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnterprisePlanV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 70,
    viewBox: "0 0 71 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.365875,
    width: 70,
    height: 70,
    rx: 12,
    fill: "#FEEFD1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.8659 25.5469C39.5486 25.5469 40.9128 24.1827 40.9128 22.5H42.319C42.319 24.1827 43.6831 25.5469 45.3659 25.5469V26.9531C43.6831 26.9531 42.319 28.3173 42.319 30H40.9128C40.9128 28.3173 39.5486 26.9531 37.8659 26.9531V25.5469ZM21.6159 33.75C25.758 33.75 29.1159 30.3921 29.1159 26.25H31.6159C31.6159 30.3921 34.9738 33.75 39.1159 33.75V36.25C34.9738 36.25 31.6159 39.6079 31.6159 43.75H29.1159C29.1159 39.6079 25.758 36.25 21.6159 36.25V33.75ZM41.9284 37.5C41.9284 39.7436 40.1095 41.5625 37.8659 41.5625V43.4375C40.1095 43.4375 41.9284 45.2564 41.9284 47.5H43.8034C43.8034 45.2564 45.6222 43.4375 47.8659 43.4375V41.5625C45.6222 41.5625 43.8034 39.7436 43.8034 37.5H41.9284Z",
    fill: "#F9AD19"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterprisePlanV2);
export default __webpack_public_path__ + "static/media/enterprise_plan_v2.c1094206e91c70975700bc727a11880a.svg";
export { ForwardRef as ReactComponent };